export const environment = {
    production: true,

    // Area1
    // serviceBaseUrl: 'https://gw.env.eurofins.fr/gsplanninguat/',
    // GServiceBaseUrl: 'https://gw.env.eurofins.fr/gsuat/',
    // GSPerviceBaseUrl: 'https://gw.env.eurofins.fr/gsprelevementuat/',
    // demetraUrl: 'https://demetrauat.envfr.area1.eurofins.local/',
    // launcherUrl: 'https://launcheruat.env.eurofins.fr/',

    // ETFR
    serviceBaseUrl: 'https://apigw.etfr.eurofins.com/gsplanninguat/server/',
    GSServiceBaseUrl: 'https://apigw.etfr.eurofins.com/gsuat/server/',
    GSPServiceBaseUrl: 'https://apigw.etfr.eurofins.com/gsprelevementuat/server/',
    demetraUrl: 'https://demetrauat.etfr.eurofins.com/',
    launcherUrl: 'https://launcheruat.etfr.eurofins.com/',

    appName: 'GS Planning',
    appCode: 'APP0000039',
    name: 'UAT'
  };
  